export default {"src":"/_next/static/media/job_hunt.adee238b.svg","height":705,"width":726};